<template>
    <div>
        <!-- <ConfirmModal :controller="controller.confirmModal" v-if="controller.confirmModal != null"></ConfirmModal>
        <SuccessModal :controller="controller.successModal" v-if="controller.successModal != null"></SuccessModal>
        <SerialModal :controller="controller.serialModal" v-if="controller.serialModal != null"></SerialModal>
        <PdpaContentModal :controller="controller.pdpaContentModal" v-if="controller.pdpaContentModal != null"></PdpaContentModal>
        <AlertModal :controller="controller.alertModal" v-if="controller.alertModal != null"></AlertModal> -->
        <LoadingModal :controller="controller.loadingModal" v-if="controller.loadingModal != null"></LoadingModal>
    </div>
</template>
<script>
//Generic modal
// import ConfirmModal from './ComfirmModal/ConfirmModal.vue';
// import SuccessModal from './SuccessModal/SuccessModal.vue';
// import SerialModal from './SerialModal/SerialModal.vue';
// import PdpaContentModal from './PdpaContentModal/PdpaContentModal.vue';
// import AlertModal from './AlertModal/AlertModal.vue';
import LoadingModal from './LoadingModal/LoadingModal.vue';

export default {
    name: 'ModalMaster',
    props: {
        controller: Object,
    },
    components: {
        // ConfirmModal,
        // SuccessModal,
        // SerialModal,
        // PdpaContentModal,
        // AlertModal,
        LoadingModal,
    },
    data: function () {
        return {
        };
    },
    created: function () {
    }
}
</script>
